import { render, staticRenderFns } from "./RoomNameExample.vue?vue&type=template&id=97ae5e7e&scoped=true&lang=pug"
import script from "./RoomNameExample.vue?vue&type=script&lang=ts"
export * from "./RoomNameExample.vue?vue&type=script&lang=ts"
import style0 from "./RoomNameExample.vue?vue&type=style&index=0&id=97ae5e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ae5e7e",
  null
  
)

export default component.exports